// extracted by mini-css-extract-plugin
export default {"tag":"TagItem_tag__-1mfK","active":"TagItem_active__m-8pk"};